/* Zboostowani: wspólna obsługa wyboru pakietu i spisów treści produktów. */
(function () {
  'use strict';
  if (window.__zbProductNavigationBound) return;
  window.__zbProductNavigationBound = true;

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;

    var link = event.target.closest(
      '[data-zb-product-toc] a[href^="#"], a[href="#zb-wybor-pakietu"], a[href="#zb-faq"], a.zb-yt-anchor[href^="#"]'
    );
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;

    var main = document.getElementById('MainContent');
    if (!main || !main.contains(link)) return;

    var href = link.getAttribute('href');
    var id;
    try { id = decodeURIComponent(href.slice(1)); } catch (error) { return; }
    var target = document.getElementById(id);

    // Numer szablonu zmienia się po imporcie motywu. Odszukujemy aktualny element.
    if (id === 'zb-wybor-pakietu') {
      target = main.querySelector('[id^="variant-selects-"]') || target;
    } else if (id === 'zb-faq') {
      var faq = main.querySelector('[data-zb-native-faq], [id*="webrex_ai_seo_schema_faq_section"]');
      if (faq) target = faq.querySelector('h2') || faq;
    }
    if (!target || !target.getClientRects().length) return;

    event.preventDefault();
    var top = target.getBoundingClientRect().top + window.scrollY - 120;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'instant' : 'smooth' });

    try {
      history.replaceState(history.state, '', href);
    } catch (error) {
      // Niektóre osadzone podglądy ograniczają zmianę adresu; przewijanie nadal działa.
    }

    var focusTarget = id === 'zb-wybor-pakietu' ? (target.querySelector('legend') || target) : target;
    if (focusTarget.getAttribute('aria-hidden') === 'true') return;
    if (!focusTarget.hasAttribute('tabindex')) {
      focusTarget.setAttribute('tabindex', '-1');
      focusTarget.addEventListener('blur', function () {
        focusTarget.removeAttribute('tabindex');
      }, { once: true });
    }
    focusTarget.focus({ preventScroll: true });
  });
}());
